import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import NotificationBell from "@/components/NotificationBell";
import VerifiedBadge from "@/components/VerifiedBadge";
import { LogOut } from "lucide-react";

/**
 * Right-side account cluster in the header. Signed-in users see a notification
 * bell, their handle chip, and a logout button. Guests see Sign in / Join CTAs.
 */
export default function UserMenu({ user, onLogout }) {
  const nav = useNavigate();

  if (user) {
    return (
      <>
        <NotificationBell />
        <div className="hidden sm:flex items-center gap-2 border border-[#2A2A2A] px-3 h-9 bg-black/60">
          <div className="h-5 w-5 grid place-items-center bg-[#FF4500] text-black font-mono font-bold text-[10px]">
            {(user.display_name || user.username)[0].toUpperCase()}
          </div>
          <span data-testid="header-username" className="font-mono text-[11px] text-gray-300">
            @{user.username}
          </span>
          {user.verified && <VerifiedBadge size={12} />}
        </div>
        <Button
          data-testid="logout-btn"
          variant="ghost"
          size="sm"
          onClick={onLogout}
          className="rounded-none hover:bg-white/10 h-9"
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </>
    );
  }

  return (
    <>
      <Button
        data-testid="login-btn"
        variant="ghost"
        size="sm"
        onClick={() => nav("/login")}
        className="hidden sm:inline-flex rounded-none font-mono text-xs uppercase tracking-widest h-9"
      >
        Sign in
      </Button>
      <Button
        data-testid="register-btn"
        size="sm"
        onClick={() => nav("/register")}
        className="rounded-none bg-[#FF4500] hover:bg-[#E53E00] text-black font-mono text-xs uppercase tracking-widest h-9 px-4"
      >
        Join MeloCraft
      </Button>
    </>
  );
}
